import * as types from "../store/types";

export const mixin = {
  props: {
    matricule: {
      type: String, required: true
    }
  },
  computed: {
    currentSen() {
      return this.$store.getters[types.ACCEDE_SEN_PAR_MATRICULE](this.matricule);
    }
  }
};



// WEBPACK FOOTER //
// ./src/components/Senateur.mixin.js